import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.21.10_@oxc-project+types@0.140.0_@parcel+watcher@2.5.6_@types+node@25.7.0_@vue+compile_h5axbsexjoyelecx457nrx7sgq/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}